<template><!-- svgo-optimised -->
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.45661 4.5H14.5434L15.4525 14.5H0.547516L1.45661 4.5Z" stroke="currentColor"/>
  <path d="M11.5 7C11.5 1.5 9 1 8.00022 1C7.00043 1 4.5 1.5 4.5 7" stroke="currentColor"/>
</svg>
</template>